import {t} from "@lingui/core/macro";
import React from "react";

import {useLocation} from "@khan/urls";

import {renderInfoToast} from "#notifications-package/toast-notification.tsx";

const DocumentCopiedToast = () => {
    const {queryParams} = useLocation();

    React.useEffect(() => {
        if (queryParams.copied) {
            renderInfoToast(t`Copy is saved in My Documents`);
        }
    }, [queryParams.copied]);

    return null;
};

export default DocumentCopiedToast;
